import styled from 'styled-components';

const ButtonWrapper = styled.button`
`;

export default ButtonWrapper;